import { v1, validate } from 'uuid';
import { EntityIdAdapter } from '../EntityIdAdapter';

export class V1UuidAdapter implements EntityIdAdapter {
  public isId(id: string): boolean {
    return validate(id);
  }

  public generateNewId(): string {
    return v1();
  }

  public getNanoSecondsTimeStampFromId(id: string): number {
    const timeLow = id.substring(0, 8);
    const timeMid = id.substring(9, 13);
    const timeHigh = id.substring(15, 18);

    return parseInt(timeHigh + timeMid + timeLow, 16);
  }

  public getNodeIdFromId(id: string): string {
    return id.substring(24);
  }
}
